<template>
  <div :key="Math.random()">
    <div style="max-width: 1904px" :style="containerStyle" class="mx-auto scroll-container">
      <div id="grid-layout-container" class="grid-layout-container" :style="layoutStyles">
        <grid-row class="pa-0 ma-0">
          <grid-col v-for="(widget, ind) in permittedWidgets" :key="ind" :cols="widget.columns" class="pa-0 ma-0" :class="xs ? 'mb-3' : 'mb-0'">
            <widget :config="enhanceConfig(widget, ind)" :key="`widget_${ind}`"></widget>
          </grid-col>
        </grid-row>
      </div>
    </div>
  </div>
</template>

<script>
import GridRow from './GridRow';
import GridCol from './GridCol';
import Widget from '@/view-widgets/Widget';
import common from '@/mixins/common';
import utils, { rCols as responsiveCols } from '@/common/utils';

export default {
  name: 'GridLayout',
  mixins: [common],
  components: {
    GridRow,
    GridCol,
    Widget,
  },
  methods: {
    enhanceConfig(config, index) {
      if (this.$route.meta.configIdentifier) {
        const { idPath } = this.$route.meta.configIdentifier;
        return { configId: `${idPath}/${index}`, ...config };
      }
      return config;
    },
  },
  computed: {
    viewConfig() {
      return this.$route.meta.viewConfig;
    },
    permittedWidgets() {
      let user = JSON.parse(localStorage.getItem('user') || '{}');
      let { userName, groups } = user;

      if (!this.viewConfig) return [];
      return this.viewConfig.widgets;
    },
    bgImgConfig() {
      return this.viewConfig.backgroundImg ? this.viewConfig.backgroundImg[this.themeName] : null;
    },
    widgetBgImgConfig() {
      if (!this.bgImgConfig) return null;
      let conf = responsiveCols(this.bgImgConfig, this.breakpoint.name);
      console.debug('resulting widgetBgImgConfig', JSON.stringify(conf, null, 2));
      return conf;
    },
    bgImg() {
      if (this.widgetBgImgConfig) {
        return this.widgetBgImgConfig.img;
      }
      return null;
    },
    backgroundPosition() {
      if (!this.widgetBgImgConfig) return null;
      return this.widgetBgImgConfig.position;
    },
    containerStyle() {
      let styles = {};
      let conf = this.bgImgConfig ? responsiveCols(this.bgImgConfig, this.breakpoint.name) : null;
      if (conf && conf.styles) {
        styles = conf.styles;
      }

      if (this.viewConfig.background) {
        console.debug('this.viewConfig.background[this.themeName]', this.themeName, this.viewConfig.background[this.themeName]);
        styles.background = `${this.viewConfig.background[this.themeName]} !important`;
      }
      return styles;
    },
    layoutStyles() {
      let style = { ...this.bgImgStyle };
      if (this.viewConfig.layoutStyles) {
        style = { ...style, ...this.viewConfig.layoutStyles };
      }
      return style;
    },
    bgImgStyle() {
      let style = {};

      if (this.bgImg) {
        style = {
          background: `url('${this.assetUrl(this.bgImg)}')`,

          // minHeight: 'calc(100vh - 160px)',
          backgroundPosition: this.backgroundPosition,
        };
      }
      if (this.isToolbarsHidden) {
        style.transform = 'translateY(-60px)';
      }
      //style.height = `calc(100vh - ${this.toolbarsHeight}px)`;
      style.minHeight = '100%';
      // style.minHeight = `calc(100vh - ${this.toolbarsHeight}px)`;
      style.alignContent = 'start';
      return style;
    },
  },
};
</script>
<style scoped>
.grid-layout-container {
  background-repeat: no-repeat;
  background-size: cover !important;
}
</style>
